<template>
  <div>
    <Head title="Create Project" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">Projects</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>

    <ProjectForm
      :form="form"
      :organizations="organizations"
      :projects="projects"
      :isAdmin="isAdmin"
      :showOrganizationField="true"
      :submit="store"
    >
      <template #actions>
        <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/projects">Go back</Link>
        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Create project</loading-button>
      </template>
    </ProjectForm>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ProjectForm from '@/Pages/Projects/ProjectForm.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    ProjectForm,
  },
  layout: Layout,
  props: {
    projects: Array,
    organizations: Array,
    loggedUser: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        cleanup_hours: 48,
        organization_id: this.loggedUser.organization_id || null,
      }),
    }
  },
  computed: {
    isAdmin() {
      return this.loggedUser.type === 'ADMIN'
    },
  },
  methods: {
    store() {
      this.form.post('/projects')
    },
  },
}
</script>
